<div class="sig-wrap">
  <canvas
    #c
    class="sig-canvas"
    (pointerdown)="start($event)"
    (pointermove)="move($event)"
    (pointerup)="end()"
    (pointerleave)="end()"
  ></canvas>
  <button type="button" class="sig-clear" (click)="clear()">
    {{ 'questionnaire.Clear signature' | translate }}
  </button>
</div>
